import { render, staticRenderFns } from "./select-task.vue?vue&type=template&id=68d21b85"
import script from "./select-task.vue?vue&type=script&lang=js"
export * from "./select-task.vue?vue&type=script&lang=js"
import style0 from "./select-task.vue?vue&type=style&index=0&id=68d21b85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports